import { Navigate } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { useAuth } from '../contexts/AuthContext'
import NotFound from '../pages/NotFound'

function AdminGuard({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Loader2 className="w-8 h-8 animate-spin text-dclaw-600" />
      </div>
    )
  }

  // 未登录 → 重定向到管理员登录页
  if (!user) {
    return <Navigate to="/admin/login" replace />
  }

  // 已登录但非管理员 → 显示 404
  if (Number(user.is_admin) !== 1) {
    return <NotFound />
  }

  // 管理员 → 渲染子组件
  return children
}

export default AdminGuard
